import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-choice-with-opinion',
  templateUrl: './disable-choice-with-opinion.component.html',
  styleUrls: ['./disable-choice-with-opinion.component.css'],
})
export class DisableChoiceWithOpinionComponent {
  @Input() question!: Question;
}
